import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-list-bulk-toolbar',
  templateUrl: './list-bulk-toolbar.component.html',
  styleUrls: ['./list-bulk-toolbar.component.scss'],
})
export class ListBulkToolbarComponent {
  @Input() selectedCount = 0;
  @Input() showStatus = false;
  @Input() showPriority = false;
  @Input() showArchive = false;
  @Input() showDelete = false;
  /** CR-17 — Export selected rows via F3. */
  @Input() showExport = false;
  /** null shows both Archive and Unarchive; true/false shows only the one that applies. */
  @Input() archived: boolean | null = null;
  @Input() busy = false;

  @Output() changeStatus = new EventEmitter<MouseEvent>();
  @Output() changePriority = new EventEmitter<MouseEvent>();
  @Output() archive = new EventEmitter<boolean>();
  @Output() deleteSelected = new EventEmitter<void>();
  @Output() exportSelected = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();
}
